import { get, isNaN, round, isEmpty } from 'lodash';

// constants
import { applicationTypes } from 'constants/scripts';

// utils
import { formatDateToISO8601 } from 'util/formatters/dateFormatter';

export const formatPlantingPlanParams = (plantingPlanParams) => {
  if (plantingPlanParams.date) {
    plantingPlanParams.date = formatDateToISO8601(plantingPlanParams.date);
  }

  plantingPlanParams['num-zones'] = parseInt((plantingPlanParams['num-zones'] || 0), 10);
  plantingPlanParams['target-yield'] = isNaN(parseInt(plantingPlanParams['target-yield'], 10))
    ? plantingPlanParams['target-yield']
    : parseInt(plantingPlanParams['target-yield'], 10);
  if (plantingPlanParams['price-commodity']) {
    plantingPlanParams['price-commodity'] = isNaN(parseInt(plantingPlanParams['price-commodity'], 10))
      ? plantingPlanParams['price-commodity']
      : round(parseFloat(plantingPlanParams['price-commodity']), 2);
  }
  if (plantingPlanParams['price-product']) {
    plantingPlanParams['price-product'] = isNaN(parseInt(plantingPlanParams['price-product'], 10))
      ? plantingPlanParams['price-product']
      : round(parseFloat(plantingPlanParams['price-product']), 2);
  }
  return plantingPlanParams;
};

export const mergePlantingPlanParams = ({ currentParams, newParams }) => {
  const newApplication = get(newParams, `products.${applicationTypes.APPLICATIONV2}`, {});
  const oldApplication = get(currentParams, `products.${applicationTypes.APPLICATIONV2}`,[]);
  return {
    ...currentParams,
    ...newParams,
    products: {
      [applicationTypes.SEED]: Object.assign(
        get(currentParams, `products.${applicationTypes.SEED}`, {}),
        get(newParams, `products.${applicationTypes.SEED}`, {})
      ),
      [applicationTypes.FERTILIZER]: Object.assign(
        get(currentParams, `products.${applicationTypes.FERTILIZER}`, {}),
        get(newParams, `products.${applicationTypes.FERTILIZER}`, {})
      ),
      [applicationTypes.APPLICATION]: Object.assign(
        get(currentParams, `products.${applicationTypes.APPLICATION}`, {}),
        get(newParams, `products.${applicationTypes.APPLICATION}`, {})
      ),
      [applicationTypes.APPLICATIONV2]: 
      oldApplication && (oldApplication.includes(newApplication) || isEmpty(newApplication))
        ? oldApplication.filter(x => x !== newApplication)
        : [
          ...oldApplication,
          newApplication
        ]
    }
  };
};
